export default __webpack_public_path__ + "static/media/TrophyImage.b7f7f47a.svg";